import React from 'react';
import { observer } from 'mobx-react';
import { NumberType } from '@bringg/types';
import CustomerConfiguration from '../../../stores/customer-configurations/domain-objects/customer-configuration';
import { Option, Select } from '../../../components';
import TagCustomerConfiguration from '../../../stores/tag-customer-configurations/tag-customer-configuration';
import { DISPLAYED_NOTIFICATION_COLLECTION } from '../notification-template/notification-template.consts';
import CheckboxOption from './checkbox-option';

interface Props {
	customerConfiguration: CustomerConfiguration | TagCustomerConfiguration;
	showPrivateMode: boolean;
	enableModeKey: string;
	privateModeKey: string;
	enableOptions: { label: any; value: any }[];
	enableFreeSmsMode: boolean;
}

const SelectEnableOption = ({
	privateModeKey,
	enableModeKey,
	enableOptions,
	customerConfiguration,
	showPrivateMode,
	enableFreeSmsMode
}: Props) => {
	const { messageType } = DISPLAYED_NOTIFICATION_COLLECTION[enableModeKey];
	const enabledMode = customerConfiguration[enableModeKey] ?? 0;
	const privateMode = customerConfiguration[privateModeKey] ?? false;
	const freeSmsMode = customerConfiguration.smsSettings[messageType] === NumberType.FreeSms;

	return (
		<div className="enable-option">
			<Select
				value={enabledMode}
				onChange={mode => customerConfiguration.setValue(enableModeKey, mode)}
				data-test-id="enable-option-select"
			>
				{enableOptions.map(({ value, label }) => (
					<Option value={value} key={value.toString()}>
						{label}
					</Option>
				))}
			</Select>

			{enabledMode !== 0 && showPrivateMode && (
				<CheckboxOption
					checked={privateMode}
					onChange={({ target }) => customerConfiguration.setValue(privateModeKey, target.checked)}
					translateKey="CUSTOMER_CONFIGURATION_VIEW.ENABLE_PRIVATE_MODE"
					testAtrr="enable-private-mode-checkbox"
				/>
			)}

			{enableFreeSmsMode && (
				<CheckboxOption
					checked={freeSmsMode}
					onChange={({ target }) => customerConfiguration.setFreeSms(messageType, target.checked)}
					translateKey="CUSTOMER_CONFIGURATION_VIEW.FREE_SMS_MODE"
					translateDefault="Send Free SMS"
					testAtrr="enable-free-sms-checkbox"
				/>
			)}
		</div>
	);
};

export default observer(SelectEnableOption);
